import { Form, Modal, Select, SelectItem } from 'carbon-components-react';

import './SBAForm.scss';
import CustomButton from '../../components/custom-button/custom-btn.component';
import { getQueryString, useReducerSpread } from '../../utils/common.util';
import useSWR from 'swr';
import { useHistory } from 'react-router-dom';
import { useClassAccessList } from '../../api/class.service';
import { postMethod } from '@/api/common';
import { useCustomMutation } from '@/utils/useCustomMutation';

const initialData = {
  academicYearId: '',
  termId: '',
  classId: '',
};

export default function CreateSBAModal({
  isOpen,
  closeModal,
  setExternalFormData,
}) {
  const [formData, setFormData] = useReducerSpread(initialData);

  const { data: academicYears } = useSWR(
    'academic-year/list/?skip=0&take=100&query=',
  );
  const { data: terms } = useSWR(
    formData.academicYearId
      ? `academic-year/terms/?academicYearId=${formData.academicYearId}`
      : null,
  );

  const { classAccessList: classes } = useClassAccessList();

  function handleClose() {
    setFormData(initialData);
    closeModal();
  }

  const history = useHistory();

  const { trigger, error, isMutating } = useCustomMutation(
    `academic/grading/initialize-school-based-assessments`,
    (url, { arg }) => postMethod(url, arg),
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    await trigger(formData, {
      onSuccess: () => {
        history.push(`/sba-subjects-view?${getQueryString(formData)}`);
        setExternalFormData && setExternalFormData(formData);
        handleClose();
      },
    });
  };

  return (
    <Modal
      id="create-sba-modal"
      className="create-sba-modal"
      hasScrollingContent
      passiveModal={true}
      open={isOpen}
      modalHeading="Create SBA Record"
      primaryButtonDisabled={false}
    >
      <Form onSubmit={handleSubmit}>
        <p className="text-14 text-grey-dark">
          Select various options to create an SBA record.
        </p>

        <div className="mt-20" style={{ display: 'grid', gap: '20px' }}>
          <Select
            labelText="Academic Year"
            onChange={(e) =>
              setFormData({ academicYearId: e.target.value, termId: '' })
            }
            value={formData.academicYearId}
          >
            <SelectItem value="" text="" />
            {academicYears?.map((year) => (
              <SelectItem
                key={year.id}
                value={year.id}
                text={year.description}
              />
            ))}
          </Select>
          <Select
            labelText="Term"
            disabled={!formData.academicYearId}
            onChange={(e) => setFormData({ termId: e.target.value })}
            value={formData.termId}
          >
            <SelectItem value="" text="" />
            {terms?.map((term) => (
              <SelectItem
                key={term.id}
                value={term.id}
                text={term.description}
              />
            ))}
          </Select>
          <Select
            labelText="Class"
            onChange={(e) =>
              setFormData({ classId: e.target.value, subjectId: '' })
            }
            value={formData.classId}
          >
            <SelectItem value="" text="" />
            {classes?.map((term) => (
              <SelectItem
                key={term.id}
                value={term.id}
                text={term.description}
              />
            ))}
          </Select>
        </div>

        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}

        <div
          style={{
            marginTop: '30px',
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CustomButton
            classes="outline danger no-hover font-bold"
            style={{ flex: '1' }}
            onClick={handleClose}
          >
            CLOSE
          </CustomButton>

          <CustomButton
            type="submit"
            style={{ flex: '1' }}
            classes={`primary font-bold`}
            isLoading={isMutating}
            disabled={
              !formData.academicYearId || !formData.termId || !formData.classId
            }
          >
            Submit
          </CustomButton>
        </div>
      </Form>
    </Modal>
  );
}
